import { GetSeatDetailsState } from './getSeatDetails.types'

const initialState: GetSeatDetailsState = {
  loading: false,
  error: null,
  success: null
  // Initialize any additional state properties here
}

export default initialState
